import { defineFilterSpec, enumField, multiField, text } from '@/lib/api/filter-spec';

import type { WarrantyClaimListFilters, WarrantyFilterFormValues } from './types';

/** Single declaration of the warranty list filters, shared by api + the filter drawer. Field names
 *  are the backend's (`ListWarrantyClaimsQueryDto`): `categoryIds`, `orderDate*`, `claimDate*`.
 *  `multiField`'s comma-join is fine in the POST body — the DTO's `toArrayLikeStringArray` accepts a
 *  joined string as readily as an array. Date bounds pass through as `YYYY-MM-DD`.
 *  No Customer filter — the Warranty AC omits it (grilling Q10), though the DTO would accept one. */
const spec = defineFilterSpec<WarrantyClaimListFilters, WarrantyFilterFormValues>([
  text('search'),
  multiField('deviceIds'),
  multiField('categoryIds'),
  multiField('cities'),
  multiField('warrantyStatuses'),
  multiField('claimStatuses'),
  multiField('reasons'),
  enumField('orderDateFrom'),
  enumField('orderDateTo'),
  enumField('claimDateFrom'),
  enumField('claimDateTo'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
export const hasActiveFilters = spec.hasActiveFilters;
